import get from 'lodash/get'

import {
  RECEIVED_AUTH_USER
} from '../modules/auth/actions'
import {
  RECEIVED_USER_COOKIE,
  receivedCookieUser
} from '../modules/session/actions'
import { firestore } from '../utils/firebase'

export default store => next => action => {
  switch (action.type) {
    case RECEIVED_USER_COOKIE:
      next(action)

      if (get(action, 'userCookie.email') && !unsubscribe) {
        startSyncingCookieUser(store, action.userCookie)
      }

      break

    case RECEIVED_AUTH_USER:
      next(action)
      stopSyncingFirebaseUser()
      break

    default:
      next(action)
  }
}

let unsubscribe

export function startSyncingCookieUser (store, userCookie) {
  unsubscribe = firestore
    .collection('users')
    .where('email', '==', userCookie.email)
    .onSnapshot(query => {
      if (query.docs.length) {
        store.dispatch(receivedCookieUser(query.docs[0].data()))
      }
    })
}

export function stopSyncingFirebaseUser () {
  unsubscribe && unsubscribe()
}
